import Icon from "@material-ui/icons/Assistant";
import AssistantList from "./AssistantList";
import AssistantShow from "./AssistantShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "busAssistants",
  list: AssistantList,
  show: AssistantShow,
  icon: Icon,
};
